import script from "./Details.vue?vue&type=script&setup=true&lang=js"
export * from "./Details.vue?vue&type=script&setup=true&lang=js"

import "./Details.vue?vue&type=style&index=0&id=5b67d2a3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b67d2a3"]])

export default __exports__